
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Minibusonrentinmumbai() {



    const cardData =
    {
        keyword: 'Mini Bus On Rent in Mumbai',
        heading: 'Skyline Cabs: Mini Bus On Rent in Mumbai',
        headingDescription: '​Skyline Cabs offers comfortable and reliable Mini Bus on Rent in Mumbai services for all your group travel needs. Whether you are planning a corporate outing, a family trip, or a special event, our well-maintained mini buses and professional drivers ensure a smooth and enjoyable journey. Enjoy door-to-door pickups from anywhere in Mumbai, transparent pricing, flexible travel schedules, and 24/7 customer support. Book your mini bus rental with Skyline Cabs today and experience hassle-free group travel across Maharashtra and beyond!',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "Built in 1924, the Gateway of India is one of Mumbai’s most iconic landmarks. Overlooking the Arabian Sea, this grand archway was constructed to commemorate the visit of King George V and Queen Mary. It’s a popular spot for tourists and locals alike, offering ferry rides to Elephanta Caves and scenic sunset views."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, this historic railway station is a masterpiece of Victorian Gothic architecture blended with Indian elements. Formerly known as Victoria Terminus, it is both a functioning railway station and an architectural marvel that reflects Mumbai’s colonial past."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coast of South Mumbai. It’s a favorite hangout for evening strolls, sunsets, and panoramic views of the city skyline. At night, the streetlights resemble a string of pearls, adding to its charm."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, a short ferry ride from the Gateway of India, these UNESCO-listed rock-cut caves date back to the 5th–8th centuries. The caves are famous for their stunning sculptures and carvings dedicated to Lord Shiva, especially the majestic Trimurti sculpture."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple in Prabhadevi is one of the most visited temples in Mumbai. Known for its spiritual energy and the faith it inspires, it draws thousands of devotees, including Bollywood celebrities and politicians."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and tomb located on an islet off the coast of Worli, Haji Ali Dargah is a symbol of Mumbai’s religious harmony. Connected to the mainland by a narrow causeway, it is both a pilgrimage site and an architectural gem offering serene sea views."
    },
    {
        "title": "Chor Bazaar",
        "description": "One of the oldest markets in Mumbai, Chor Bazaar is famous for antiques, vintage collectibles, furniture, and quirky treasures. Wandering through its crowded alleys offers a unique shopping experience and a glimpse into the city’s diverse culture and heritage."
    },
    {
        "title": "Juhu Beach",
        "description": "A popular beach destination in suburban Mumbai, Juhu Beach is known for its street food stalls, Bollywood celebrity homes, and leisurely atmosphere. It's the perfect spot for a seaside walk or indulging in local snacks like pav bhaji and bhel puri."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, this massive national park is a green escape from the urban hustle. Home to leopards, deer, and countless bird species, it also features the ancient Kanheri Caves and offers nature trails, boating, and safaris."
    },
    {
        "title": "Colaba Causeway",
        "description": "A bustling street market near the Gateway of India, Colaba Causeway is a shopper’s paradise filled with street stalls, boutiques, cafes, and colonial-era architecture. It’s ideal for picking up souvenirs, fashion, accessories, and enjoying Mumbai’s cosmopolitan vibe."
    }
],

"services": [
    {
      "name": "Mini Bus Rental in Mumbai",
      "description": "Skyline Cabs offers mini bus rentals in Mumbai for all your travel needs. Ideal for group trips, events, or tours with spacious and well-maintained vehicles."
    },
    {
      "name": "Rent Mini Bus for Travel in Mumbai",
      "description": "Looking to travel around Mumbai in a group? Rent a mini bus from Skyline Cabs for a comfortable and convenient experience."
    },
    {
      "name": "Mumbai Mini Bus Hire for Groups",
      "description": "Hire a mini bus in Mumbai with Skyline Cabs for group travel. Perfect for family outings, team trips, and group tours."
    },
    {
      "name": "Mini Bus on Rent for Wedding",
      "description": "Planning a wedding in Mumbai? Rent a mini bus from Skyline Cabs to ensure smooth and stylish guest transportation on your special day."
    },
    {
      "name": "Mini Bus for Corporate Events Mumbai",
      "description": "Skyline Cabs provides mini buses for corporate events in Mumbai. Make employee or client travel efficient and comfortable."
    },
    {
      "name": "Mumbai Mini Bus Booking",
      "description": "Book a mini bus in Mumbai easily with Skyline Cabs. Our online platform makes booking quick and hassle-free for all group travel needs."
    }
  ],
  "tableData": [
    ["Mini Bus Rental in Mumbai", "Rent Mini Bus for Travel in Mumbai"],
    ["Mumbai Mini Bus Hire for Groups", "Mini Bus on Rent for Wedding"],
    ["Mini Bus for Corporate Events Mumbai", "Mumbai Mini Bus Booking"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Mini Bus on Rent in Mumbai",
      "WhyChoosedescription": "Rent a mini bus in Mumbai for comfortable and convenient group travel. Ideal for family outings, corporate events, school trips, and tours across the city or outstation."
    },
    {
      "WhyChooseheading": "Spacious and Group-Friendly Seating",
      "WhyChoosedescription": "Our mini buses offer ample space with comfortable seating arrangements for 18 to 35 passengers, ensuring a relaxed journey for all."
    },
    {
      "WhyChooseheading": "Perfect for All Occasions",
      "WhyChoosedescription": "Whether it’s a wedding function, corporate retreat, religious tour, or city sightseeing, our mini buses are suitable for every group event."
    },
    {
      "WhyChooseheading": "Modern Amenities for a Comfortable Ride",
      "WhyChoosedescription": "Enjoy features like air conditioning, push-back seats, music systems, and large windows for a pleasant and enjoyable travel experience."
    },
    {
      "WhyChooseheading": "Well-Trained and Courteous Drivers",
      "WhyChoosedescription": "Our drivers are experienced, professional, and punctual—ensuring your journey is smooth, safe, and on schedule."
    },
    {
      "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Buses",
      "WhyChoosedescription": "All vehicles undergo regular maintenance and sanitization to provide a hygienic and safe ride, every time you travel."
    },
    {
      "WhyChooseheading": "Flexible Rental Plans and Packages",
      "WhyChoosedescription": "We offer hourly, daily, and customized rental plans to suit your unique travel needs in and around Mumbai."
    },
    {
      "WhyChooseheading": "24/7 Booking Assistance and Support",
      "WhyChoosedescription": "Book easily online or via phone, and our dedicated support team is available 24/7 to help with your mini bus rental requirements in Mumbai."
    }
  ]
  
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I rent a mini bus in Mumbai with Skyline Cabs?',
            answer:
                'Renting a mini bus in Mumbai is easy with Skyline Cabs. You can book through our website, mobile app, or by calling our customer support. Just provide your travel date, pickup location, and group size to get started.',
        },
        {
            id: 2,
            question: 'What seating capacities are available for mini buses?',
            answer:
                'We offer mini buses in multiple seating capacities including 17, 20, 26, and 32-seater options. They are perfect for weddings, school/college trips, corporate outings, and group tours.',
        },
        {
            id: 3,
            question: 'Is the mini bus suitable for long-distance travel?',
            answer:
                'Yes, our mini buses are ideal for both local and outstation trips. They are equipped with comfortable seating, ample luggage space, air conditioning, and experienced drivers for a smooth journey.',
        },
        {
            id: 4,
            question: 'Are the rental prices for mini buses in Mumbai fixed?',
            answer:
                'Yes, we offer fixed and transparent pricing for mini bus rentals. The fare includes the vehicle, driver charges, fuel, tolls, parking, and applicable taxes. You’ll get the complete fare breakdown before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I rent a mini bus for one day or multiple days?',
            answer:
                'Yes, you can rent a mini bus for a few hours, one day, or multiple days, depending on your travel needs. Just share your itinerary and we will customize the package accordingly.',
        },
        {
            id: 6,
            question: 'Are the mini buses air-conditioned?',
            answer:
                'Yes, all our mini buses are fully air-conditioned and well-maintained to provide a comfortable experience for all passengers.',
        },
        {
            id: 7,
            question: 'Is mini bus rental available for weddings and events?',
            answer:
                'Absolutely! Our mini buses are frequently used for weddings, family functions, school/college trips, and corporate events. We can also arrange vehicle decoration or branding on request.',
        },
        {
            id: 8,
            question: 'What payment options are available for mini bus rental in Mumbai?',
            answer:
                'We accept UPI, credit/debit cards, net banking, and cash payments. Online transactions are secure and confirmed via email or SMS.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my mini bus booking?',
            answer:
                'Yes, bookings can be modified or cancelled via our website, app, or by contacting customer support. We offer flexible cancellation policies to accommodate changes in your travel plans.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for mini bus rental in Mumbai?',
            answer:
                'Skyline Cabs offers clean, comfortable mini buses with professional drivers and all-inclusive pricing. Our reliable service and excellent customer support make us a preferred choice for group travel in and around Mumbai.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Prakash Nair",
            rating: 5,
            review: "We booked a mini bus for our family trip to Nashik from Mumbai. The vehicle was in excellent condition, the driver was courteous, and everything went smoothly. Will definitely use Skyline Cabs again!"
        },
        {
            name: "Mrs. Kavita Joshi",
            rating: 4,
            review: "Rented a 26-seater mini bus for a wedding function in Mumbai. The bus was neat, spacious, and the AC worked well. Pickup was a bit delayed but the service was good overall."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus On Rent in Mumbai",
  "image": "https://skylinecabs.com/assets/images/mini-bus-on-rent-mumbai.jpg",
  "description": "Book Mini Bus on rent in Mumbai with Skyline Cabs for group travel, corporate trips, family functions, or school outings. Choose from 17, 20, 26, and 32-seater AC buses with pushback seats, experienced drivers, and affordable pricing.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8431"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5200",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mini-bus-on-rent-in-mumbai"
  }
};


      
      


    return (
        <div>
<Helmet>
  <title>Mini Bus On Rent in Mumbai | 17, 20, 32 Seater Bus Hire | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mini Bus on rent in Mumbai with Skyline Cabs for group travel, corporate trips, family functions, or school outings. Choose from 17, 20, 26, and 32-seater AC buses with pushback seats, experienced drivers, and affordable pricing." 
  />
  <meta 
    name="keywords" 
    content="Mini Bus On Rent in Mumbai, 17 Seater Bus Hire Mumbai, 20 Seater Bus Rental, 26 Seater AC Bus Booking, 32 Seater Bus on Hire Mumbai, Mini Bus for Group Tour Mumbai, AC Bus for Marriage, Corporate Bus Rental Mumbai, Skyline Cabs Bus Hire" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/90.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Minibusonrentinmumbai;